import { format, isToday, isWithinInterval, subDays } from 'date-fns';
import { FC } from 'react';
import { defaultAnimationOptions } from 'src/components/constants';
import { LottieAnimation } from 'src/components';
import tick from './tick-animation.json';
import * as S from './styles';

interface Props {
  count: number;
  date: Date;
}

export const Day: FC<Props> = ({ count, date }) => {
  const today = new Date();

  if (isToday(date)) {
    return (
      <S.AnimationContainer data-testid="animation-container">
        <LottieAnimation animationData={tick} {...defaultAnimationOptions} />
      </S.AnimationContainer>
    );
  } else {
    return (
      <S.ButtonContainer
        data-testid="button-container"
        $isHighlighted={isWithinInterval(date, {
          start: subDays(today, count),
          end: today,
        })}
      >
        {format(date, 'd')}
      </S.ButtonContainer>
    );
  }
};
